export function some<A>(set: Set<A>, fn: (value: A) => boolean) {
  for (const value of set) {
    if (fn(value)) return true
  }
  return false
}

export function filter<A>(set: Set<A>, fn: (value: A) => boolean) {
  const newSet = new Set<A>()

  for (const value of set) {
    if (fn(value)) newSet.add(value)
  }

  return newSet
}

export function slice<A>(set: Set<A>, start: number, end: number) {
  const setArray = Array.from(set)
  const slicedArray = setArray.slice(start, end)
  const slicedSet = new Set(slicedArray)

  return slicedSet
}

export function map<A, U>(set: Set<A>, fn: (value: A) => U) {
  const newSet = new Set<U>()

  for (const value of set.values()) {
    newSet.add(fn(value))
  }

  return newSet
}

export function first<A>(set: Set<A>) {
  const first = set.values().next()

  if (!first.done) return first.value

  return undefined
}

export function union<A>(...sets: Set<A>[]) {
  return sets.reduce((combined, list) => {
    return new Set([...combined, ...list])
  }, new Set())
}

export function add<A>(set: Set<A>, newElement: A) {
  return new Set(set).add(newElement)
}

export function remove<A>(set: Set<A>, element: A) {
  const newSet = new Set(set)
  newSet.delete(element)
  return newSet
}

export function find<A>(set: Set<A>, fn: (value: A) => boolean) {
  for (const value of set) {
    if (fn(value)) return value
  }

  return undefined
}
